'use strict';

var $ = require('jquery');
var ajax = require('../utils/ajax');
var countries = require('./country-selection/countries');
var util = require('../utils/util');
var keyCodes = require('../constants/key-codes');

function isActive($target) {
    return !$target.hasClass('toggle-disabled') && !($target.parents('.toggle-disabled').length > 0);
}

/**
 * @description apply focus on toggle
 */
function applyToggleFocus() {
    var toggleFocusID = null;

    if (window.location.hash) {
        toggleFocusID =
            location.hash.substr(1).indexOf('&') > 0 || location.hash.substr(1).indexOf('=') > 0
                ? null
                : location.hash.substr(1);
    } else {
        var sectionParam = new RegExp('[?&]' + 'section' + '=([^&#]*)').exec(window.location.href);
        toggleFocusID = sectionParam !== null ? sectionParam[1] : null;
    }

    if (toggleFocusID) {
        var $focusToggle = $('.toggle-container#' + toggleFocusID);

        if ($focusToggle.length > 0) {
            var $toggle = $focusToggle.children('.toggle');
            var duration = $toggle.data('toggle-duration') || 400;
            var $parentToggles = $focusToggle.parents('.toggle-container');
            var nextOrPrev = $toggle.hasClass('show-more') ? 'prev' : 'next';

            $parentToggles.each(function () {
                var $currentToggle = $(this).children('.toggle');
                var currentNextOrPrev = $currentToggle.hasClass('show-more') ? 'prev' : 'next';
                $currentToggle
                    .toggleClass('expanded')
                    [currentNextOrPrev]('.toggle-content')
                    .slideToggle(duration)
                    .toggleClass('content-expanded')
                    .attr('aria-expanded', $currentToggle.hasClass('expanded'));
            });

            $toggle
                .toggleClass('expanded')
                [nextOrPrev]('.toggle-content')
                .slideToggle(duration)
                .toggleClass('content-expanded')
                .attr('aria-expanded', $currentToggle.hasClass('expanded'));

            util.scrollBrowser($focusToggle.offset().top, true);
        }
    }
}

/**
 * @description apply focus on toggle for Cosmetics CLP banner text
 */
function applyToggleFocusCosmetics() {
    var $toggleCosmeticsContainer = $('.toggle-container-cosmetics');
    var $toggleCosmetics = $toggleCosmeticsContainer.children('.toggle-cosmetics');

    $toggleCosmetics.on('click', function (event) {
        event.preventDefault();
        $toggleCosmeticsContainer.toggleClass('m-opened');
    });
}

/**
 * @function
 * @description helper function to check if coupon code accordion toggle is initially expanded for different views
 */
function isPreferenceForCouponCodeInitialToggleMet($toggleContent) {
    var preferenceMet = $toggleContent.hasClass('content-expanded-init-desktop') && !util.isMobileOrTablet();
    preferenceMet = preferenceMet
        ? true
        : $toggleContent.hasClass('content-expanded-init-mobile') && util.isMobileOrTablet();
    return preferenceMet;
}

function closeForMobile() {
    // Even with Expanded class, on mobile it starts closed
    $(window).on('load', function () {
        var screenwidth = window.innerWidth;
        if (screenwidth <= 767) {
            var $container = $('.toggle-container.expanded:not(.has-error)');
            if (!$container.hasClass('content-expanded-init-mobile')) {
                $container.find('.toggle-content').hide().removeClass('content-expanded');
                $container.find('.toggle').removeClass('expanded').attr('aria-expanded', 'false');
            }
        }
    });
}

function collapseTablet() {
    $(window).on('load', function () {
        var screenwidth = window.innerWidth;
        var $container = $('.toggle-container.tablet-collapsed:not(.has-error)');
        if (screenwidth >= 768 && screenwidth <= 1023 && !$container.hasClass('content-expanded-init-mobile')) {
            if (!$container.hasClass('content-expanded-init-mobile')) {
                $container.find('.toggle-content').hide().removeClass('content-expanded');
                $container.find('.toggle').removeClass('expanded').attr('aria-expanded', 'false');
            }
        }
    });
}

function navigateBackward(e, $container) {
    e.preventDefault();
    var $tabbable = $container.findTabbable();
    var $firstTabbable = $tabbable.first();
    var $lastTabbable = $tabbable.last();
    var $element = $(e.target);
    var currentPosition = $tabbable.index($element);
    var $previousElement = $tabbable[--currentPosition];

    if ($element.is($firstTabbable)) {
        $lastTabbable.focus();
    } else {
        $previousElement.focus();
    }
}

function navigateForward(e, $container) {
    e.preventDefault();
    var $tabbable = $container.findTabbable();
    var $firstTabbable = $tabbable.first();
    var $lastTabbable = $tabbable.last();
    var $element = $(e.target);
    var currentPosition = $tabbable.index($element);
    var $nextElement = $tabbable[++currentPosition];

    if ($element.is($lastTabbable)) {
        $firstTabbable.focus();
    } else {
        $nextElement.focus();
    }
}

function FindKey(elm, char) {
    var foundNext = false;
    var next = $(elm);

    if ($(next).parent().hasClass('content-asset')) {
        next = $(next).parent().next();
    } else {
        next = $(elm).next();
    }
    while (!foundNext && !$(elm).is(next) && !$(elm).is(next.find('.toggle'))) {
        if (next.hasClass('toggle')) {
            if ($(next).text().charAt(0).trim().toLocaleLowerCase() == char.toLocaleLowerCase()) {
                $(next).focus();
                foundNext = true;
            }
            next = $(next).next();
        } else if (next.hasClass('content-asset')) {
            if ($(next).find('.toggle').text().trim().charAt(0).toLocaleLowerCase() == char.toLocaleLowerCase()) {
                $(next).find('.toggle').focus();
                foundNext = true;
            }
            next = $(next).next();
        } else if (next.is('a')) {
            if ($(next).text().trim().charAt(0).toLocaleLowerCase() == char.toLocaleLowerCase()) {
                $(next).focus();
                foundNext = true;
            }
            next = $(next).next();
        } else if (next.length == 0) {
            if ($(elm).parent().hasClass('content-asset')) {
                next = $(elm).closest('.content-asset').parent().children().first();
            } else {
                next = $(elm).parent().children().first();
            }
        } else {
            next = $(next).next();
        }
    }
}

function handleMenuKeys(e, elm, $container) {
    var closeExpand;

    if ($(elm).hasClass('expanded')) {
        closeExpand = true;
    }

    if (e.which === keyCodes.ENTER || e.which === keyCodes.SPACE) {
        $(elm).click();
        $(elm).next('.toggle-content').children().first().focus();
        if (closeExpand) {
            $(elm).focus();
        }
    } else if (e.which === keyCodes.ESCAPE) {
        $('.header-mobile-menu-trigger').click();
        $('.header-mobile-menu-trigger').focus();
        $('.header-mobile-menu-trigger').attr('aria-expanded', 'false');
    } else if (e.which === keyCodes.HOME) {
        if ($(elm).parent().hasClass('mobile-menu-section')) {
            $('.mobile-menu-section > .toggle:first-child').focus();
        } else if ($(elm).parent().hasClass('toggle-content')) {
            $(elm).parent().children().first().focus();
        }
    } else if (e.which === keyCodes.END) {
        if ($(elm).parent().hasClass('mobile-menu-section')) {
            $('.mobile-menu-section > div:last-child  .toggle').focus();
        } else if ($(elm).parent().hasClass('toggle-content')) {
            if ($(elm).parent().children().last().hasClass('toggle-content')) {
                $(elm).parent().find('.toggle:last').focus();
            } else {
                $(elm).parent().children().last().focus();
            }
        }
    } else if (e.which === keyCodes.DOWN) {
        navigateForward(e, $container);
    } else if (e.which === keyCodes.UP) {
        navigateBackward(e, $container);
    } else if ((e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 48 && e.keyCode <= 57)) {
        // Letter Key
        var char = String.fromCharCode(e.keyCode);
        FindKey(elm, char);
    }
}

function closeAllContentWithChildren($toggleContent, duration) {
    $toggleContent.find('.toggle').removeClass('expanded').attr('aria-expanded', 'false');
    $toggleContent.find('.toggle-content').slideUp(duration).removeClass('content-expanded');
    $toggleContent.slideUp(duration);
}

function closeAllWithChildren($toggle, duration) {
    $toggle.removeClass('expanded').attr('aria-expanded', 'false');
    $toggle
        .siblings('.toggle')
        .add($toggle.siblings('.content-asset').children('.toggle'))
        .removeClass('expanded')
        .attr('aria-expanded', 'false');

    closeAllContentWithChildren(
        $toggle.siblings('.toggle-content').add($toggle.siblings('.content-asset').children('.toggle-content')),
        duration
    );

    if ($toggle.parent().hasClass('content-asset')) {
        $toggle
            .parent()
            .siblings('.toggle')
            .add($toggle.parent().siblings('.content-asset').children('.toggle'))
            .removeClass('expanded')
            .attr('aria-expanded', 'false');
        closeAllContentWithChildren(
            $toggle
                .parent()
                .siblings('.toggle-content')
                .add($toggle.parent().siblings('.content-asset').children('.toggle-content')),
            duration
        );
    }
}

function getUrlParameter(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return false;
}

var toggle = {
    init: function ($target, targetIsContainer) {
        var isContainer = targetIsContainer || false;

        $('.toggle-list .toggle, .toggle-list > a, .toggle-list .toggle-content > a').on('keydown', function (event) {
            if ($(this).parents('.refinements-filters').length > 0) {
                return;
            }
            var screenwidth = window.innerWidth;
            if (screenwidth <= 767) {
                handleMenuKeys(event, this, $target);
            }
        });

        var initToggle = function ($toggle, isContainer) {
            var nextOrPrev = $toggle.hasClass('show-more') ? 'prev' : 'next';
            var $toggleContent = $toggle[nextOrPrev]('.toggle-content');
            var $toggleList = $toggle.closest('.toggle-list');
            var onlyOneSectionAllowed = $toggleList.data('toggle-only-one-section') || false;
            var multiLevelToggle = (isContainer && $toggleList.data('multi-level-toggle')) || false;
            var scrollToggleFlyin = $toggleList.data('scroll-toggle-flyin') || false;
            var closeOnMouseLeave = $toggleList.data('toggle-close-on-mouse-leave') || false;
            var duration = $toggle.data('toggle-duration') || 400;

            var toggleSectionFromURL = getUrlParameter('section');

            if ($toggle.parents('.refinements-filters').length > 0) {
                return;
            }

            if (toggleSectionFromURL) {
                $('[data-target="' + toggleSectionFromURL + '"]').click();
            }

            $toggleList.children('.content-asset').each(function (index) {
                $(this)
                    .children('.toggle')
                    .attr('id', 'asset-toggle-' + index)
                    .attr('aria-controls', 'asset-toggle-content-' + index)
                    .attr('role', 'menuitem')
                    .attr('aria-expanded', 'false');
                $(this)
                    .children('.toggle-content')
                    .attr('id', 'asset-toggle-content-' + index)
                    .attr('aria-labelledby', 'asset-toggle-' + index)
                    .attr('role', 'region');
            });

            if (multiLevelToggle) {
                $toggle.on('click', function (event) {
                    var $usablenetButton = $('.ocd-flyin').find('.usablenet-header-container');
                    var usablenetButtonTop = $usablenetButton.length > 0 ? $usablenetButton.offset().top : 0;
                    var wasExpanded = $toggle.hasClass('expanded');
                    $toggle.attr('aria-expanded', !wasExpanded);

                    event.preventDefault();
                    closeAllWithChildren($toggle, duration);

                    if (!wasExpanded) {
                        $toggle.addClass('expanded').attr('aria-expanded', 'true');
                        $toggleContent.slideDown(duration, function () {
                            if (scrollToggleFlyin) {
                                var $container = $('.ocd-flyin');

                                $container.animate({
                                    scrollTop:
                                        $toggle.offset().top -
                                        $container.offset().top +
                                        $container.scrollTop() -
                                        usablenetButtonTop
                                });
                            }
                        });
                    } else if (scrollToggleFlyin) {
                        var $container = $('.ocd-flyin');
                        var $element = $toggle.parent().prev();

                        if (!$element || $element.length === 0) {
                            $element = $toggle.parent().children().first();
                        }

                        $container.animate({
                            scrollTop:
                                $element.offset().top -
                                $container.offset().top +
                                $container.scrollTop() -
                                usablenetButtonTop
                        });
                    }
                });
            } else {
                var expandedTimeout;
                $toggle.on('keydown', function (event) {
                    clearTimeout(expandedTimeout);
                    if (event.keyCode === 13) {
                        //Enter
                        $(this).click();
                    }
                });
                $toggle.on('click', function (event) {
                    clearTimeout(expandedTimeout);
                    event.preventDefault();

                    if (onlyOneSectionAllowed) {
                        $toggleList
                            .find('.toggle-content')
                            .not($toggleContent)
                            .slideUp(duration)
                            .removeClass('content-expanded content-expanded-init-mobile content-expanded-init-desktop');
                        $toggleList
                            .find('.toggle')
                            .not($toggle)
                            .removeClass('expanded content-expanded-init-mobile content-expanded-init-desktop');
                    }

                    if ($toggleContent.html() && $toggleContent.html().trim() === '' && $toggleContent.data('url')) {
                        ajax.load({
                            url: $toggleContent.data('url'),
                            target: $toggleContent,
                            callback: function () {
                                // here specific init actions for the snippets just loaded are possible
                                // 1st example below is the country selector toggle, which isn't loaded at
                                // page load but in the moment first time expanding the toggle
                                if ($toggleContent.find('div.country-select').length) {
                                    countries.init($toggleContent.find('.country-select'));
                                }
                            }
                        });
                    }

                    $toggleContent[$toggle.hasClass('expanded') ? 'slideUp' : 'slideDown']({
                        duration: duration
                    });

                    expandedTimeout = setTimeout(function () {
                        var $labelLess = $('.toggle-label-less');
                        var $labelMore = $('.toggle-label-more');
                        var screenwidth = window.innerWidth;
                        var isCosmeticsPage = $('body').hasClass('m-cosmetics');
                        var isProductAccordeon = $toggle.parents().hasClass('product-material-accordeon');
                        var isMobile = screenwidth <= 1023 ? true : false;
                        $toggle.toggleClass('expanded');

                        if (isCosmeticsPage && isProductAccordeon && isMobile) {
                            var headerHeight = $('.header-wrapper.hide-on-desktop').height();

                            $('html').animate(
                                {
                                    scrollTop: $toggle.offset().top - headerHeight
                                },
                                0
                            );
                        }

                        $toggle.attr('aria-expanded', $toggle.hasClass('expanded'));
                        $labelLess.attr('aria-hidden', $labelLess.is(':visible') ? 'false' : 'true');
                        $labelMore.attr('aria-hidden', $labelMore.is(':visible') ? 'false' : 'true');
                    }, duration);
                });

                if (closeOnMouseLeave) {
                    $toggleContent.mouseleave(function (e) {
                        e.preventDefault();

                        $toggle
                            .removeClass('expanded')
                            .removeClass('content-expanded-init-mobile content-expanded-init-desktop')
                            .attr('aria-expanded', 'false');
                        $toggleContent
                            .slideUp(duration)
                            .removeClass('content-expanded content-expanded-init-mobile content-expanded-init-desktop');
                    });
                }
            }
        };

        if ($target && !isContainer) {
            if (isActive($target)) {
                if (!$target.hasClass('expanded')) {
                    var nextOrPrev = $target.hasClass('show-more') ? 'prev' : 'next';
                    $target[nextOrPrev]('.toggle-content').hide().removeClass('content-expanded');
                }

                applyToggleFocus();
                applyToggleFocusCosmetics();
                closeForMobile();

                initToggle($target);
            }
        } else {
            var $toggleNotExpanded = $('.toggle:not(.expanded)');
            var nextOrPrev = $toggleNotExpanded.hasClass('show-more') ? 'prev' : 'next';
            var $toggleContent = $toggleNotExpanded[nextOrPrev]('.toggle-content');

            var couponCodeAccordionExpanded = isPreferenceForCouponCodeInitialToggleMet($toggleContent);

            if (!couponCodeAccordionExpanded) {
                $toggleContent.hide().removeClass('content-expanded');
            } else {
                var $cartCouponCodeLabel = $('.cart-coupon-code-label').first();
                $cartCouponCodeLabel.addClass('expanded');
                $cartCouponCodeLabel.attr('aria-expanded', 'true');
                $toggleContent.addClass('content-expanded');
            }

            applyToggleFocus();
            applyToggleFocusCosmetics();
            closeForMobile();
            collapseTablet();

            $toggleContent.removeClass('content-expanded-init-mobile content-expanded-init-desktop');

            (isContainer ? $target.find('.toggle') : $('.toggle')).each(function () {
                var $this = $(this);

                if (isActive($this)) {
                    initToggle($this, isContainer);
                }
            });
        }
    }
};

exports.init = toggle.init;
